import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/teacher-terms-page-banner.jpeg" alt="Teacher Terms & Conditions Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>T</span>
                                    <span>E</span>
                                    <span>A</span>
                                    <span>C</span>
                                    <span>H</span>
                                    <span>E</span>
                                    <span>R</span>
                                    <span>&nbsp;</span>
                                    <span>P</span>
                                    <span>O</span>
                                    <span>L</span>
                                    <span>I</span>
                                    <span>C</span>
                                    <span>Y</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}